import { getExpressionData } from "api/expression";
import { getTagData } from "api/tags";

const kpiConfig = {
  getTagData,
  getExpressionData
};

export default kpiConfig;